import { baseUrl, baseRealtyUrl } from '@capcenter/shared';

const numberOfListings = 500;

export default async function getElasticSearchListings(data: { isRealty: boolean, state: string, county?: string, city?: string }) {
    const { isRealty, county, state, city } = data;

    let elasticBaseUrl = baseUrl;
    if (isRealty) {
        elasticBaseUrl = baseRealtyUrl;
    }

    const body = (city && county) ? getCityRequestBody(state, county, city) : getStateRequestBody(state);

    return window.fetch(`${elasticBaseUrl}/elastic/listings/_search`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(body)
    });
}

function getCityRequestBody(state: string, county: string, city: string) {
    return {
        "size": numberOfListings,
        "sort": [{
            "isCapcenterListing": {
                "order": "desc"
            }
        }, {
            "OnMarketDate": {
                "order": "desc"
            }
        }],
        "query": {
            "function_score": {
                "query": {
                    "bool": {
                        "filter": [{
                            "exists": {
                                "field": "ListPrice"
                            }
                        }, {
                            "exists": {
                                "field": "location"
                            }
                        }, {
                            "bool": {
                                "should": [{
                                    "term": {
                                        "PropertyType.keyword": "Residential"
                                    }
                                }, {
                                    "term": {
                                        "PropertyType.keyword": "Residential Income"
                                    }
                                }, {
                                    "term": {
                                        "PropertyType.keyword": "Land"
                                    }
                                }]
                            }
                        }, {
                            "term": {
                                "StandardStatus.keyword": "Active"
                            }
                        }, {
                            "bool": {
                                "must": [{
                                    "match": {
                                        "CountyOrParish": county
                                    }
                                }, {
                                    "match": {
                                        "StateOrProvince": state
                                    }
                                }, {
                                    "match": {
                                        "City": city
                                    }
                                }]
                            }
                        }],
                        "should": [],
                        "must": [],
                        "must_not": []
                    }
                }
            }
        },
        "_source": ["id", "normalized_address", "ListPrice", "location", "ccCounty", "CloseDate", "ListingId", "City", "CountyOrParish", "PostalCode", "StandardStatus", "StreetDirPrefix", "StreetSuffix", "StreetDirSuffix", "StreetName", "StreetNumber", "StateOrProvince", "OriginatingSystemName", "UnitNumber", "UnparsedAddress", "ListOfficeMlsId", "isCapcenterListing", "OnMarketDate", "AddressUrlString"]
    }
}

function getStateRequestBody(state: string) {
    return {
        "size": numberOfListings,
        "sort": [{
            "OnMarketDate": {
                "order": "desc"
            }
        }],
        "query": {
            "function_score": {
                "query": {
                    "bool": {
                        "filter": [{
                            "exists": {
                                "field": "ListPrice"
                            }
                        }, {
                            "exists": {
                                "field": "location"
                            }
                        }, {
                            "bool": {
                                "should": [{
                                    "term": {
                                        "PropertyType.keyword": "Residential"
                                    }
                                }, {
                                    "term": {
                                        "PropertyType.keyword": "Residential Income"
                                    }
                                }, {
                                    "term": {
                                        "PropertyType.keyword": "Land"
                                    }
                                }]
                            }
                        }, {
                            "term": {
                                "StandardStatus.keyword": "Active"
                            }
                        }, {
                            "bool": {
                                "must": [{
                                    "match": {
                                        "StateOrProvince": state
                                    }
                                }]
                            }
                        }],
                        "should": [{
                            "constant_score": {
                                "filter": {
                                    "term": {
                                        "isCapcenterListing": "true"
                                    }
                                },
                                "boost": 1
                            }
                        }],
                        "must": [],
                        "must_not": []
                    }
                },
                "random_score": {
                    "seed": 10,
                    "field": "_seq_no"
                },
                "boost_mode": "sum"
            }
        },
        "_source": ["id", "normalized_address", "ListPrice", "location", "ccCounty", "CloseDate", "ListingId", "City", "CountyOrParish", "PostalCode", "StandardStatus", "StreetDirPrefix", "StreetSuffix", "StreetDirSuffix", "StreetName", "StreetNumber", "StateOrProvince", "OriginatingSystemName", "UnitNumber", "UnparsedAddress", "ListOfficeMlsId", "isCapcenterListing", "OnMarketDate", "AddressUrlString"]
    }
}